var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',_vm._l((_vm.tabsFieldsSchema),function(tab,i){return _c('el-tab-pane',{key:i,attrs:{"label":tab.label}},_vm._l((tab.fields),function(component,x){return _c('component-compiler',{key:x,attrs:{"content":component}})}),1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }